import { makeStyles } from '@material-ui/core/styles';

import { AssetStatuses } from 'hooks/useAssets/useAssets.types';

export const useStyles = makeStyles(theme => {
  const mapStatusIconPlacement = {
    [AssetStatuses.ACTIVE]: {
      width: theme.spacing(3.5),
      height: theme.spacing(2.5),
      top: theme.spacing(3),
    },
    [AssetStatuses.INACTIVE]: {
      width: theme.spacing(2.5),
      height: theme.spacing(2.5),
      top: theme.spacing(3),
    },
    [AssetStatuses.INSTALLED]: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      top: theme.spacing(3),
    },
    [AssetStatuses.ISSUED]: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      top: theme.spacing(3),
    },
    [AssetStatuses.VERIFIED]: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      top: theme.spacing(3),
    },
  };

  return {
    statusContainer: {
      position: 'relative',
    },
    assetIcon: {
      height: theme.spacing(9),
      width: theme.spacing(9),
    },
    statusIcon: ({ status }: { status: AssetStatuses }) => {
      const { height, top, width } = mapStatusIconPlacement[status] || {};
      return {
        position: 'absolute',
        top,
        left: '50%',
        transform: 'translate(-50%)',
        zIndex: 1,
        height,
        width,
      };
    },
    treeDotIcon: {
      height: theme.spacing(3),
      width: theme.spacing(4),
    },
  };
});
